import React from "react";
import { Dialog, DialogContent, Button } from "@mui/material";
import { modalBackdropProps } from "../../utils/styles/modal.overlay";
import ModalCloseButton from "../../components/UI/ModalCloseButton";

function ExitConfirmDialog({ open, onClose, onConfirm, title }) {
  const headingText = title || "Are you sure you want to exit?";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      BackdropProps={modalBackdropProps}
      PaperProps={{
        style: {
          borderRadius: "5px",
          padding: "28px 24px",
          position: "relative",
          minWidth: "520px",
          backgroundColor: "var(--primary-popup-background-color)",
          border: "1px solid var(--primary-popup-stroke-color)",
          color: "var(--primary-text-color)",
        },
      }}
    >
      <ModalCloseButton onClick={onClose} />

      <DialogContent
        style={{
          padding: 0,
          textAlign: "center",
          marginTop: "20px",
        }}
      >
        <h2
          style={{
            fontFamily: "Poppins",
            fontWeight: 400,
            color: "var(--primary-text-color)",
            fontSize: "20px",
            margin: "0 0 32px 0",
          }}
        >
          {headingText}
        </h2>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "40px",
            marginTop: "60px",
          }}
        >
          <Button
            onClick={onConfirm}
            style={{
              fontSize: "14px",
              fontFamily: "Poppins",
              fontWeight: 500,
              backgroundColor: "var(--primary-popup-background-color)",
              color: "var(--primary-text-theme-color)",
              textTransform: "none",
              border: "2px solid",
              borderColor: "var(--primary-text-theme-color)",
              padding: "10px 28px",
              minWidth: "150px",
              borderRadius: "4px",
            }}
          >
            Yes
          </Button>
          <Button
            onClick={onClose}
            style={{
              fontSize: "14px",
              fontFamily: "Poppins",
              fontWeight: 500,
              backgroundColor: "var(--primary-button-background-color)",
              color: "var(--primary-button-text-color)",
              textTransform: "none",
              padding: "10px 28px",
              minWidth: "150px",
              borderRadius: "4px",
            }}
          >
            No
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ExitConfirmDialog;
